module.exports = __webpack_public_path__ + "img/pic_bg1.f1881033.jpg";